import { Directive, ElementRef, Input } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

@Directive({
  selector: '[set-route-class]'
})
export class SetRouteClassDirective {

  @Input('set-route-class') routes: string[] = [];

  constructor(private router: Router, eleRef: ElementRef) {
    this.router.events
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          var url = this.removeQueryStrings(event.url);
          var addClass = false;
          for (let r of this.routes) {
            if (r === "" || r === "/") {
              if (url === "/") {
                addClass = true;
              }
            }
            else if (url.indexOf("/" + r) !== -1) {
              addClass = true;
            }
          }

          if (addClass) {
            eleRef.nativeElement.classList.add("active");
          }
          else {
            eleRef.nativeElement.classList.remove("active");
          }
        }

      });

  }

  removeQueryStrings(url: string): string {
    var qIdx = url.indexOf("?");

    if (qIdx !== -1) {
      return url.substr(0, qIdx);
    }
    else {
      return url;
    }
  }

}
